import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
import Link from "../../../basics/Link"
import { router } from "../../../../utility/router"
import { PageContext } from "../../Page"

const MenuDevelopers = ({ closeMenuFunction = () => { } }) => {
  const context = useContext(PageContext)
  const [t] = useTranslation("layout")

  return <>
    <div className="h-full p-5 border-r">
      <h5 className="text-blue-10">{t('header.devsMenu.title')}</h5>
      <div className="text-small text-midnight-20 mt-1">{t('header.devsMenu.description')}</div>
    </div>

    <div className="h-full px-5 pt-5 pb-3.5 col-span-2">
      <Link to={router('developers.api', context.folder)} className="text-xs pb-1.5 block" onClick={() => closeMenuFunction()}>
        {t('header.devsMenu.api')}
      </Link>
      <Link to={router('developers.fabrick-producers', context.folder)} className="text-xs py-1.5 block" onClick={() => closeMenuFunction()}>
        {t('header.devsMenu.producers')}
      </Link>
      <Link to={router('developers.tpp-portal', context.folder)} className="text-xs py-1.5 block" onClick={() => closeMenuFunction()}>
        {t('header.devsMenu.tpp')}
      </Link>
      <Link to={'https://www.platfr.io/#/platfr/login'} blank className="text-xs py-1.5 block">{t('header.devsMenu.consumerPortal')}</Link>

      {/* <Link to={router('developers.assistenza-tecnica', context.folder)} className="text-xs py-1.5 block">{t('header.devsMenu.support')}</Link> */}
    </div>
  </>
}

export default MenuDevelopers